import type { DemandeActions } from '../shared'

export const AF_INJECT = Symbol('af-inject')

export type DemandeAFActions = DemandeActions
